export interface ReferralTier {
  level: string;
  commission: string;
  rate: number;
}

export interface ReferralPlan {
  maxLevels: number;
  tiers: ReferralTier[];
}

export const PLAN_10_LEVELS: ReferralPlan = {
  maxLevels: 10,
  tiers: [
    { level: "1st", commission: "5%", rate: 0.05 },
    { level: "2nd", commission: "3%", rate: 0.03 },
    { level: "3rd", commission: "3%", rate: 0.03 },
    { level: "4th", commission: "3%", rate: 0.03 },
    { level: "5th", commission: "2%", rate: 0.02 },
    { level: "6th", commission: "2%", rate: 0.02 },
    { level: "7th", commission: "1%", rate: 0.01 },
    { level: "8th", commission: "0.5%", rate: 0.005 },
    { level: "9th", commission: "0.3%", rate: 0.003 },
    { level: "10th", commission: "0.2%", rate: 0.002 },
  ],
};

export const PLAN_5_LEVELS: ReferralPlan = {
  maxLevels: 5,
  tiers: [
    { level: "1st", commission: "5%", rate: 0.05 },
    { level: "2nd", commission: "3%", rate: 0.03 },
    { level: "3rd", commission: "2%", rate: 0.02 },
    { level: "4th", commission: "1%", rate: 0.01 },
    { level: "5th", commission: "1%", rate: 0.01 },
  ],
};
